import React from 'react';
import { Interstitial, Carousel } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { CheckoutFormInitiatedOnType } from '@gik/checkout/types';
import Slider from 'react-slick';
import { Product } from '@gik/core/models/gik/Product';
import ExternalProductPage from './ExternalProductPage';
import SendEmailPage from './SendEmailPage';

export const blockName = `external-product-interstitial`;

export interface ExternalProductInterstitialProps {
  isOpen: boolean;
  onClose(): void;
  sourceName: string;
  externalLink: string;
  shippingAddressLines?: string[];
  recipientEmail?: string;
  products?: Product[];
  inkindRouteId?: string;
  initiatedOn?: CheckoutFormInitiatedOnType;
}

export interface InterstitialEmailFormValues {
  email: string;
  subscribeToNewsletter: boolean;
}

export default function ExternalProductInterstitial({
  isOpen,
  onClose,
  children,
  sourceName,
  externalLink,
  shippingAddressLines,
  recipientEmail,
  products,
  initiatedOn,
  inkindRouteId,
}: React.PropsWithChildren<ExternalProductInterstitialProps>): React.ReactElement {
  const [sliderRef, setSliderRef] = React.useState<Slider>(null);

  function handleClose() {
    sliderRef?.slickGoTo(0);
    scrollToTop();
    if (onClose) onClose();
  }

  function onEmailLinkClicked() {
    sliderRef.slickGoTo(1);
    scrollToTop();
  }

  function scrollToTop() {
    const portals = document.getElementsByClassName('gik-interstitial__portal');
    if (portals && portals.length) {
      portals[0].scrollTop = 0;
    }
  }

  const carouselSettings = {
    adaptiveHeight: true,
    draggable: false,
    swipe: false,
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const bem = bemBlock(blockName);

  return (
    <>
      <Interstitial contentClassName={bem()} isOpen={isOpen} onClose={handleClose}>
        {isOpen && (
          <div className="gik-external-product-interstitial-carousel">
            <Carousel {...carouselSettings} ref={(el: Slider) => setSliderRef(el)}>
              <ExternalProductPage
                products={products}
                sourceName={sourceName}
                inkindRouteId={inkindRouteId}
                initiatedOn={initiatedOn}
                externalLink={externalLink}
                recipientEmail={recipientEmail}
                shippingAddressLines={shippingAddressLines}
                onEmailLinkClicked={onEmailLinkClicked}
              />
              <SendEmailPage products={products} inkindRouteId={inkindRouteId} />
            </Carousel>
          </div>
        )}
      </Interstitial>
      {children}
    </>
  );
}
